import { render, staticRenderFns } from "./deviceMonthActive.vue?vue&type=template&id=88580f18&scoped=true&"
import script from "./deviceMonthActive.vue?vue&type=script&lang=js&"
export * from "./deviceMonthActive.vue?vue&type=script&lang=js&"
import style0 from "./deviceMonthActive.vue?vue&type=style&index=0&id=88580f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88580f18",
  null
  
)

export default component.exports